<template>
    <div class="range-slider">
        <div class="w-50">
            <div class="mb-2">
                <vue-slider tooltip="none" :interval=15 :min=0 :max=1440  @change="onInput" :value="valueC" :enable-cross="false"/>
            </div>
        </div>
        <div class="form-control d-flex justify-content-between" style="max-width: 150px">
            <b>{{start}}</b>-
            <b>{{end}}</b>
        </div>
    </div>
</template>

<script>
import strpad from 'strpad'

export default {
  name: 'TimeRangeSlider',
  props: {
    value: {
      type: Array,
      default: function () {
        return [{h: 0, m: 0}, {h: 23, m: 59}]
      }
    }
  },
  computed: {
    valueC: {
      get: function () {
        const min = this.value[0].h * 60 + this.value[0].m
        const max = this.value[1].h * 60 + this.value[1].m
        return [min, max]
      },
      set: function () {
      }
    },
    start: function () {
      const value = this.value
      return strpad.left(value[0].h, 2, '0') + ':' + strpad.left(value[0].m, 2, '0')
    },
    end: function () {
      const value = this.value
      return strpad.left(value[1].h, 2, '0') + ':' + strpad.left(value[1].m, 2, '0')
    }
  },
  methods: {
    onInput: function (value) {
      const start = {h: this.h(value[0]), m: this.m(value[0])}
      const end = {h: this.h(value[1]), m: this.m(value[1])}
      this.$emit('input', [start, end])
    },
    h: function (min) {
      return Math.floor(min / 60)
    },
    m: function (min) {
      return min % 60
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/TimeRangeSlider.vue